var _g, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOccasion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26,7H6A1,1,0,0,0,5,8V26a1,1,0,0,0,1,1H26a1,1,0,0,0,1-1V8A1,1,0,0,0,26,7Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5,13H27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11,4V8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21,4V8"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16,16l1.06,3.04L20.28,19.11l-2.57,1.95L18.65,24.14,16,22.3l-2.65,1.84.94-3.08L11.72,19.11l3.22-.07Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOccasion);
export default __webpack_public_path__ + "static/media/occasion.678e8695c867a06a0fd3e511c4597e64.svg";
export { ForwardRef as ReactComponent };